import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Institute of Singapore Chartered Accountants section on Partners page
 */
const ISCASection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="isca-section-component">
      <AccordionV2
        testId="isca"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Institute of Singapore Chartered Accountants" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>About the Institute of Singapore Chartered Accountants</p>

          <p>
            The Institute of Singapore Chartered Accountants (ISCA) is the
            national accountancy body of Singapore. ISCA&apos;s vision is to be
            a world-class accountancy body of trusted professionals,
            contributing towards an innovative and sustainable economy. There
            are over 33,000 ISCA members making their stride in businesses
            across industries in Singapore and around the world.
          </p>

          <p>
            Established in 1963, ISCA is an advocate of the interests of the
            profession. Complementing its Global Mindset with Asian Insights,
            ISCA leverages its regional expertise, knowledge, and networks with
            diverse stakeholders to contribute towards the advancement of the
            accountancy profession.
          </p>

          <p>
            ISCA is the Designated Entity to confer the Chartered Accountant of
            Singapore - CA (Singapore) - designation.
          </p>

          <p>
            ISCA is a member of Chartered Accountants Worldwide, a global family
            that brings together the members of leading institutes to create a
            community of over 1.8 million Chartered Accountants and students in
            more than 190 countries.
          </p>

          <p>For more information, visit www.isca.org.sg.</p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ISCASection;
